import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";

export function TiposDocumentoHeader({
  total,
  activos,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  activos: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Tipos de documento"
      description={<><CifraCargando valor={total} /> tipos (<CifraCargando valor={activos} /> activos) · clasifican los documentos dentro de su categoría y pueden sobrescribir su revisión y vigencia.</>}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo tipo
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
